import React from "react";
import { useTranslation } from "react-i18next";
import { Link as GatsbyLink } from "gatsby";

export const linkTo = (lang, to) =>
  lang === "en" ? to : `/${lang.replace("_", "/")}${to}`;

const Link = ({ to = "", children, ...rest }) => {
  const { i18n } = useTranslation();
  const lang = i18n.language;

  const isUrl = (link) => {
    try {
      return Boolean(new URL(link));
    } catch (e) {
      return false;
    }
  };

  return isUrl(to) ? (
    <a href={to} target="_blank" {...rest}>
      {children}
    </a>
  ) : (
    <GatsbyLink to={linkTo(lang, to)} {...rest}>
      {children}
    </GatsbyLink>
  );
};

export default Link;
